import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';

// Lazy load public form page
const PublicFormPage = lazy(() => import('@/pages/forms/public'));

/**
 * Public form routes (no authentication required)
 */
export const publicFormRoutes = [
  {
    path: 'forms',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: ':slug',
        element: <PublicFormPage />,
      },
    ],
  },
];
